import { WorkHistoryItemData } from './interface';
import { Text } from '@medely/ui-kit';
import React from 'react';

export const WorkHistoryInfo = ({ workHistoryItem }: { workHistoryItem: WorkHistoryItemData }) => {
  return (
    <>
      <Text size="m" color="text.secondary" testId="work-history-item-organization-name">
        {workHistoryItem.organization_name}
      </Text>
      <Text size="m" color="text.secondary" testId="work-history-item-position">
        {workHistoryItem.position_title}
      </Text>
    </>
  );
};
